import React from 'react';
import './Cards.css';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedCard } from '../slicers/FilterSlice';

const Cards = ({ icon, count, text, onClick }) => {
  const selectedCard = useSelector((state) => state.filters.selectedCard);
  const dispatch = useDispatch();

  const handleSelection = () => {
    const newSelectedCard = selectedCard === text ? null : text;
    dispatch(setSelectedCard(newSelectedCard));
    if (onClick) {
      onClick(newSelectedCard);
    }
  };

  return (
    <div
      className={`custom-card ${selectedCard === text ? 'selected-card' : ''}`}
      onClick={handleSelection}
    >
      <div className="icon-row">
        <h2 className="card-count">{count}</h2>
        <div className="text-row" style={{color: selectedCard === text ? "black" :"#373737" }}>
          <div style={{marginTop:"0px !important"}}>{text}</div>
        </div>
        <div style={{flex:1}}></div>
        {icon}
      </div>
    </div>
  );
};


export default Cards;
